import { useState } from "react";
import {
  Input,
  Form,
  Modal,
  Typography,
  Flex,
  Space,
  Button,
  InputNumber,
  App,
} from "antd";

import { createGroup, updateGroup, deleteGroup } from "@/api/definitionFilters";
import { DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

// Окно для создания/редактирования группы фильтров, содержит форму
const FiltersGroupModal = ({ data = {}, visible, onSave, onCancel }) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      if (data?.uuid) {
        await updateGroup({ ...data, ...values });
      } else {
        await createGroup({ ...data, ...values });
      }

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  const handleDelete = () => {
    Modal.confirm({
      title: `Вы уверены, что хотите удалить группу фильтров?`,
      content:
        "Все связанные данные будут удалены. Это действие нельзя будет отменить.",

      onOk() {
        handleConfirmDelete();
      },
      okText: "Удалить",
      cancelText: "Отмена",
      zIndex: 99999,
    });
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteGroup({ uuid: data.uuid });
      onSave();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    }
  };

  return (
    <Modal
      maskClosable={false}
      title={
        data?.uuid
          ? "Редактирование группы фильтров"
          : "Создание новой группы фильтров"
      }
      open={visible}
      onCancel={handleCancel}
      footer={
        <Flex align="center" justify="space-between">
          {data?.name && (
            <Typography.Link onClick={handleDelete} style={{ color: "red" }}>
              <Space>
                <DeleteOutlined /> Удалить группу
              </Space>
            </Typography.Link>
          )}
          <Space style={{ marginLeft: "auto" }}>
            <Button key="cancel" onClick={handleCancel}>
              Отмена
            </Button>
            <Button
              key="submit"
              type="primary"
              loading={isLoading}
              onClick={onOk}
            >
              {data?.uuid ? "Сохранить" : "Создать"}
            </Button>
          </Space>
        </Flex>
      }
      zIndex={10000}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        <Flex gap={20}>
          <Form.Item name="idx" label="№ п/п">
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            name="name"
            label="Название группы"
            rules={[
              { required: true, message: "Пожалуйста, введите название" },
            ]}
            style={{ flex: 1 }}
          >
            <Input />
          </Form.Item>
        </Flex>
        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default FiltersGroupModal;
